import React from "react";
import Style from "./recipe.module.css";
const Recipe = ({ title, calories, image, ingredients }) => {
  return (
    <div className={Style.recipe}>
      <h1>{title}</h1>
      <p>Calories:{calories}</p>
      <ol>
        {ingredients.map((ingredients) => (
          <li>{ingredients.text}</li>
        ))}
      </ol>

      <img className={Style.image} src={image}></img>
    </div>
  );
};

export default Recipe;
